import types from './types';

const INITIAL_STATE = {
  isSearching: false,
  isFetchingAttachments: false,
  isFetchingAuth: false,

  result: [],
};

const claimMemberReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

  case types.SEARCH_CLAIM_MEMBERS_REQUEST:
    return {
      ...state,
      result: [],
      isSearching: true,
    };

  case types.SEARCH_CLAIM_MEMBERS_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isSearching: false,
    };

  case types.SEARCH_CLAIM_MEMBERS_FAILURE:
    return {
      ...state,
      result: [],
      isSearching: false,
    };

  case types.GET_CLAIM_MEMBER_ATTACHMENTS_REQUEST:
    return {
      ...state,
      result: [],
      isFetchingAttachments: true,
    };

  case types.GET_CLAIM_MEMBER_ATTACHMENTS_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isFetchingAttachments: false,
    };

  case types.GET_CLAIM_MEMBER_ATTACHMENTS_FAILURE:
    return {
      ...state,
      result: [],
      isFetchingAttachments: false,
    };

  case types.GET_CLAIM_MEMBER_AUTH_DETAIL_REQUEST:
    return {
      ...state,
      result: [],
      isFetchingAuth: true,
    };

  case types.GET_CLAIM_MEMBER_AUTH_DETAIL_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isFetchingAuth: false,
    };

  case types.GET_CLAIM_MEMBER_AUTH_DETAIL_FAILURE:
    return {
      ...state,
      result: [],
      isFetchingAuth: false,
    };

  default:
    return state;
  }
};

export default claimMemberReducer;
